// import { setReport } from "./../store/ducks/onlineOrders";
// import { LambdaFunctions } from "./../constants/enums";
// import { useDispatch, useSelector } from "react-redux";
// import invokeLambda from "../services/invokeLambda";
// import useApp from "./useApp";
// import { HeadCell } from "../models/dataTable";
// const useDispatchersOrdersReport = (
//   listingName: string,
//   singleName: string
// ) => {
//   const { showConfirm, showError } = useApp();

//   const dispatch = useDispatch();

//   const onlineOrdersListing = useSelector(
//     (state: any) => state.onlineOrders.report
//   );

//   const dispatcherIDs = useSelector((state: any) =>
//     state.dispatchers.selectedFilters?.map((dispatcher: any) => dispatcher.sub)
//   );

//   const headCells: readonly HeadCell[] = [
//     {
//       id: "dispatcher",
//       numeric: false,
//       disablePadding: false,
//       label: "Dispatcher Name",
//     },
//     {
//       id: "totalorders",
//       numeric: true,
//       disablePadding: false,
//       label: "Total Orders",
//     },
//     {
//       id: "orderamount",
//       numeric: true,
//       disablePadding: false,
//       label: "Order Amount",
//     },
//     {
//       id: "deliveryfee",
//       numeric: true,
//       disablePadding: false,
//       label: "Delivery Fee",
//     },
//     {
//       id: "tax",
//       numeric: true,
//       disablePadding: false,
//       label: "Tax",
//     },
//   ];

//   const dataCells: readonly string[] = [
//     "dispatcher",
//     "totalorders",
//     "orderamount",
//     "deliveryfee",
//     "tax",
//   ];
//   interface Item {
//     dispatcherName: string;
//     totalOrders: number;
//     totalAmount: number;
//     totalDeliveryFee: number;
//     totalTax: number;
//   }

//   type RawItems = Record<string, Item>;
//   const fetch = async (requestBody: any) => {
//     function setStartOfDay(date: any) {
//       const dateObj = new Date(date);
//       dateObj.setUTCHours(0, 0, 0, 0);
//       return dateObj;
//     }

//     function setEndOfDay(date: any) {
//       const dateObj = new Date(date);
//       dateObj.setUTCHours(23, 59, 59, 999);
//       return dateObj;
//     }
//     const alldispatcherIDs = requestBody?.dispatcherID?.length
//       ? requestBody.dispatcherIDs
//       : [];

//     const body = {
//       operationId: 44,

//       startDate: setStartOfDay(requestBody.startDate),
//       endDate: setEndOfDay(requestBody.endDate),
//       dispatcherIDs,
//     };
//     console.log("body", { body });

//     try {
//       const rawItems = await invokeLambda(
//         LambdaFunctions.callCenterOperations,
//         body
//       );
//       console.log("rawItems", rawItems);

//       const itemsArray = Array.isArray(rawItems)
//         ? rawItems
//         : Object.entries(rawItems).map(([id, item]) => {
//             const typedItem = item as Item;

//             return {
//               id,
//               dispatcher: typedItem.dispatcherName,
//               totalorders: typedItem.totalOrders,
//               orderamount: `${parseFloat(
//                 typedItem.totalAmount.toFixed(2)
//               )} EGP`,
//               deliveryfee: `${parseFloat(
//                 typedItem.totalDeliveryFee.toFixed(2)
//               )} EGP`,
//               tax: `${parseFloat(typedItem.totalTax.toFixed(2))} EGP`,
//             };
//           });
//       console.log("items", itemsArray);
//       dispatch(setReport(itemsArray));
//       return itemsArray;
//     } catch (e) {
//       showError(e);
//       console.log(e);
//     }
//   };
//   const api: any = {};
//   api[`${listingName}HeadCells`] = headCells;
//   api[`${listingName}DataCells`] = dataCells;
//   api[`${listingName}Fetch`] = fetch;
//   api[`${listingName}NextToken`] = undefined;
//   api[`${listingName}Listing`] = onlineOrdersListing;
//   api[`${listingName}ChangeListing`] = (listing: any) =>
//     dispatch(setReport(listing));
//   api[`${listingName}ClearListing`] = () => dispatch(setReport([]));
//   api[`${listingName}ClearNextToken`] = () => {};

//   return api;
// };

// export default useDispatchersOrdersReport;

import { setReport } from "./../store/ducks/onlineOrders";
import { LambdaFunctions } from "./../constants/enums";
import { useDispatch, useSelector } from "react-redux";
import invokeLambda from "../services/invokeLambda";
import useApp from "./useApp";
import { HeadCell } from "../models/dataTable";

const useDispatchersOrdersReport = (
  listingName: string,
  singleName: string,
  searchText?: string // Search text for filtering
) => {
  const { showConfirm, showError } = useApp();

  const dispatch = useDispatch();

  const onlineOrdersListing = useSelector(
    (state: any) => state.onlineOrders.report
  );

  const dispatcherIDs = useSelector((state: any) =>
    state.dispatchers.selectedFilters?.map((dispatcher: any) => dispatcher.sub)
  );

  const headCells: readonly HeadCell[] = [
    {
      id: "dispatcher",
      numeric: false,
      disablePadding: false,
      label: "Dispatcher Name",
    },
    {
      id: "totalorders",
      numeric: true,
      disablePadding: false,
      label: "Total Orders",
    },
    {
      id: "orderamount",
      numeric: true,
      disablePadding: false,
      label: "Order Amount",
    },
    {
      id: "deliveryfee",
      numeric: true,
      disablePadding: false,
      label: "Delivery Fee",
    },
    {
      id: "tax",
      numeric: true,
      disablePadding: false,
      label: "Tax",
    },
  ];

  const dataCells: readonly string[] = [
    "dispatcher",
    "totalorders",
    "orderamount",
    "deliveryfee",
    "tax",
  ];

  interface Item {
    dispatcherName: string;
    totalOrders: number;
    totalAmount: number;
    totalDeliveryFee: number;
    totalTax: number;
  }

  type RawItems = Record<string, Item>;

  const fetch = async (requestBody: any) => {
    function setStartOfDay(date: any) {
      const dateObj = new Date(date);
      dateObj.setUTCHours(0, 0, 0, 0);
      return dateObj;
    }

    function setEndOfDay(date: any) {
      const dateObj = new Date(date);
      dateObj.setUTCHours(23, 59, 59, 999);
      return dateObj;
    }

    const alldispatcherIDs = requestBody?.dispatcherID?.length
      ? requestBody.dispatcherIDs
      : [];

    const body = {
      operationId: 44,
      startDate: setStartOfDay(requestBody.startDate),
      endDate: setEndOfDay(requestBody.endDate),
      dispatcherIDs,
    };
    console.log("body", { body });

    try {
      const rawItems = await invokeLambda(
        LambdaFunctions.callCenterOperations,
        body
      );
      console.log("rawItems", rawItems);

      const itemsArray = Array.isArray(rawItems)
        ? rawItems
        : Object.entries(rawItems).map(([id, item]) => {
            const typedItem = item as Item;

            return {
              id,
              dispatcher: typedItem.dispatcherName,
              totalorders: typedItem.totalOrders,
              orderamount: `${parseFloat(
                typedItem.totalAmount.toFixed(2)
              )} EGP`,
              deliveryfee: `${parseFloat(
                typedItem.totalDeliveryFee.toFixed(2)
              )} EGP`,
              tax: `${parseFloat(typedItem.totalTax.toFixed(2))} EGP`,
            };
          });

      // Apply the search filter if searchText is provided
      if (searchText) {
        const filteredItems = itemsArray.filter((item) =>
          item.dispatcher.toLowerCase().includes(searchText.toLowerCase())
        );
        console.log("Filtered Items", filteredItems);
        dispatch(setReport(filteredItems));
        return filteredItems;
      } else {
        dispatch(setReport(itemsArray));
        return itemsArray;
      }
    } catch (e) {
      showError(e);
      console.log(e);
    }
  };

  const api: any = {};
  api[`${listingName}HeadCells`] = headCells;
  api[`${listingName}DataCells`] = dataCells;
  api[`${listingName}Fetch`] = fetch;
  api[`${listingName}NextToken`] = undefined;
  api[`${listingName}Listing`] = onlineOrdersListing;
  api[`${listingName}ChangeListing`] = (listing: any) =>
    dispatch(setReport(listing));
  api[`${listingName}ClearListing`] = () => dispatch(setReport([]));
  api[`${listingName}ClearNextToken`] = () => {};

  return api;
};

export default useDispatchersOrdersReport;
